 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useEffect, useRef} from 'react'
import {useLocation} from 'react-router'
import useAtmosphere from './useAtmosphere'

const useServiceWorkerUpdater = () => {
  const atmosphere = useAtmosphere()
  const isFirstServiceWorkerRef = useRef(true)
  const sourcesAreDirtyRef = useRef(false)

  const location = useLocation()

  useEffect(() => {
    const setFirstServiceWorker = async () => {
      const registration = await navigator.serviceWorker.getRegistration()
      isFirstServiceWorkerRef.current = !registration
    }
    const onServiceWorkerChange = () => {
      // new service worker means new sources
      sourcesAreDirtyRef.current = true

      if (isFirstServiceWorkerRef.current) {
        isFirstServiceWorkerRef.current = false
        return
      }
      atmosphere.eventEmitter.emit('addSnackbar', {
        key: 'newVersion',
        autoDismiss: 5,
        message: 'A new version of Parabol is available 🎉',
        action: {
          label: `See what's changed`,
          callback: () => {
            const url = `https://github.com/ParabolInc/parabol/releases/tag/v${__APP_VERSION__}`
            _optionalChain([window, 'access', _ => _.open, 'call', _2 => _2(url, '_blank', 'noopener'), 'optionalAccess', _3 => _3.focus, 'call', _4 => _4()])
          }
        }
      })
    }
    if ('serviceWorker' in navigator) {
      setFirstServiceWorker().catch(() => {
        /*ignore*/
      })
      navigator.serviceWorker.addEventListener('controllerchange', onServiceWorkerChange)
      return () => {
        navigator.serviceWorker.removeEventListener('controllerchange', onServiceWorkerChange)
      }
    }
    return
  }, [])

  useEffect(() => {
    // When the sources are dirty, we want to reload the page as soon as possible without too much interruption for the user.
    // Let's hide it in a navigation event.
    if (sourcesAreDirtyRef.current) {
      window.location.reload()
    }
  }, [location.pathname])
}
export default useServiceWorkerUpdater
